// Echological.fm - Minimal JavaScript for subtle animations
// Intersection Observer for fade-in animations
const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
};
const observer = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        if (entry.isIntersecting) {
            entry.target.classList.add('fade-in');
            observer.unobserve(entry.target);
        }
    });
}, observerOptions);
// Observe elements on page load
document.addEventListener('DOMContentLoaded', ()=>{
    // Add fade-in animation to mission and CTA sections
    const sections = document.querySelectorAll('.mission, .cta');
    sections.forEach((section)=>{
        observer.observe(section);
    });
    // Smooth scroll for anchor links
    document.querySelectorAll('a[href^="#"]').forEach((anchor)=>{
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
                // Close mobile menu if open
                const navMenu = document.querySelector('.nav-menu');
                const hamburger = document.querySelector('.hamburger');
                if (navMenu && hamburger) {
                    navMenu.classList.remove('active');
                    hamburger.classList.remove('active');
                }
            }
        });
    });
    // Hamburger menu toggle
    const hamburger = document.querySelector('.hamburger');
    const navMenu = document.querySelector('.nav-menu');
    if (hamburger && navMenu) hamburger.addEventListener('click', ()=>{
        hamburger.classList.toggle('active');
        navMenu.classList.toggle('active');
    });
});
// Optional: Add a subtle parallax effect to hero on scroll (very lightweight)
let ticking = false;
function updateHeroParallax() {
    const hero = document.querySelector('.hero');
    if (hero && window.scrollY < window.innerHeight) {
        const scrolled = window.scrollY;
        const parallax = scrolled * 0.3;
        hero.style.transform = `translateY(${parallax}px)`;
    }
    ticking = false;
}
window.addEventListener('scroll', ()=>{
    if (!ticking) {
        window.requestAnimationFrame(()=>{
            updateHeroParallax();
            ticking = false;
        });
        ticking = true;
    }
});

//# sourceMappingURL=echologicalfm.d61874ba.js.map
